namespace('compass.map');


compass.requireLib('compass.hotel.HotelFilter');

compass.map.MapboxWidget = compass.defineWidget(function(options) {
	var me = this;
	var $j = jQuery;
	var _d = jQuery.dom.getContext(this);
	var _settings = options;
	var _WUID = _settings.WUID;
	
	// no need for redraw, we're manipulating classes in first two arg callbacks
	var _filter = new compass.hotel.HotelFilter(_setMarkerFiltered, _setMarkerUnfiltered, undefined, _redraw);
	var _hotels = _settings.hotels;
	var _currFilter = {};
	var currentMapboxStyle = _settings.mapbox.streetsStyleUrl;
	var customLoaded = false; //used to ensure we only attempt to replace streetsStyleUrl one time at most
	var styleUrls = {
		streetsStyleUrl: _settings.mapbox.streetsStyleUrl,
		satelliteStyleUrl: _settings.mapbox.satelliteStyleUrl
	};
	
	this.hotelMarkerPairs = []; // array of {hotel: hotelObj, marker: mapboxgl.Marker}
	this.siteMarkerPairs = []; // array of {site: siteObj, marker: mapboxgl.Marker}
	
	this.render = function (widgetElem) {
		this.setData(_hotels);
		widgetElem.append(_d.div({id:'mapMount'}));
		// if widget elem is visible then call draw
		if(widgetElem.is(':visible')) {
			me.draw();
		}
	};
	//mostly for use in hotelInfo view
	this.setData = function(hotels) {
		_hotels = hotels;
		_filter.setData(hotels);
	};
	
	this.updateFilter = function(filterObj) {
		_currFilter = (filterObj || _currFilter);
		_filter.updateFilter(_currFilter);
	};

	// draw is also bound to mapViewClicked
	this.draw = function(options) {
		compass.loading.start();
		// fetchmapbox sets this.draw as a callback for mapbox script el onload, so it will
		// call draw again when the mapbox library becomes available
		if (typeof mapboxgl === 'undefined') return this.fetchMapbox();
		
		me.getWidgetElem().show(); // warning: has to come before the updateFilter call

		
		var siteLngLat = [ _settings.meetingInfo.site.longitude, _settings.meetingInfo.site.latitude];
		me.boundingBox = new mapboxgl.LngLatBounds(
			[siteLngLat[0], siteLngLat[1]], 
			[siteLngLat[0], siteLngLat[1]]
		);
		
		mapboxgl.accessToken = 'pk.eyJ1Ijoib25wZWFrIiwiYSI6ImNqYTRjMGl0MzE5OHEyd2xmNGo2OTM1aXEifQ.1qKlI1sL9ZgN3F8QP7TOtg';
		me.map = new mapboxgl.Map({
			container: 'mapMount',
			/* allow for meeting rule for mapbox studio styles */
			style: _settings.meetingInfo.mapboxStyleUrl || currentMapboxStyle,
			center: siteLngLat,
			zoom: _settings.mapbox.zoom,
			trackResize: true
		});
		// if custom style exists and succeeds, replace street style URL with custom style URL (for toggle)
		if (_settings.meetingInfo.mapboxStyleUrl) {
			me.map.on('style.load', function() {
				if (!customLoaded) {
					customLoaded = true;
					styleUrls['streetsStyleUrl'] = _settings.meetingInfo.mapboxStyleUrl;
				}
			});
		}
		// switch back to default style if custom style fails to load
		me.map.once('error', function(mapError) {
			customLoaded = true;
			me.map.setStyle( styleUrls['streetsStyleUrl'] );
			if ( window.mapboxErrorFired ) return;
			window.mapboxErrorFired = true;
			jQuery.ajax({
				url : '/sendToKeen',
				type: 'POST',
				ignoreTimeout : true,
				data: JSON.stringify({ 'stream': 'compass_mapboxWidget', eventData: {message:mapError.message} }),
				dataType: 'json',
				error: function(event) {} //If call fails, suppress
			});
		});
		// disable map rotation using right click + drag
		me.map.dragRotate.disable();
		
		// disable map rotation using touch rotation gesture
		me.map.touchZoomRotate.disableRotation();

		if (_settings.useSiteMarker) {
			me.siteMarkerPair = _drawSiteMarker(_settings.meetingInfo.site);
			// itr thru altSites, calling _drawSiteMarker on each, and putting the
			// returned site-marker pairs into me.altSiteMarkers
			me.altSiteMarkerPairs = _.map(_settings.meetingInfo.alternateSites, _drawSiteMarker);
		}

		// draws hotels, puts markers in array, also updates boundingBox
		me.hotelMarkerPairs = _.map(_hotels, _drawHotelMarker);
		me.map.fitBounds(me.boundingBox, {padding: _settings.mapbox.padding});
		
		_drawMapControls();
		me.updateFilter();
		$j('.mapTab').removeClass('disabled').addClass("mapLoaded");
		compass.loading.stop();
	};
	
	function _redraw(hotels) {
		_hotels = hotels;
		_filter.setData(hotels);
		
		if( me.getWidgetElem().is(':visible') ) {

			// draws hotels, puts markers in array, also updates boundingBox
			me.hotelMarkerPairs = _.map(_hotels, _drawHotelMarker);
			me.map.fitBounds(me.boundingBox, {padding: _settings.mapbox.padding});
			
			
			_.forEach(hotels, function(hotel) {
				var hotelMarkerPair = _.find(me.hotelMarkerPairs, function(hotelMarkerPair) {
					return hotelMarkerPair.hotel.hotelId === hotel.hotelId;
				});
				
				if ( hotelMarkerPair == null ){ 
					return null;
				}
				
				hotelMarkerPair.hotel = hotel;

				var soldOut = !(hotel.avail.status === 'NORMAL' || hotel.avail.status === 'GDS');
				if(soldOut) {
					_setMarkerFiltered(hotel.hotelId)();
				} else {
					_setMarkerUnfiltered(hotel.hotelId)();
				}
			});
		}
	}

	function _drawSiteMarker(site) {
		var lnglat = new mapboxgl.LngLat(site.longitude, site.latitude);
		var siteIcon = document.createElement('img');
		siteIcon.src = compass.staticPrefix + '/resources/img/compass/map/conference.png';
		siteIcon.className = 'siteMarker';
		
		me.boundingBox.extend(lnglat);
		var siteMarker = new mapboxgl.Marker(siteIcon, {offset: [0, -19]})
			.setLngLat([site.longitude, site.latitude])
			.setPopup(_createSitePopup(site))
			.addTo(me.map);
		return {site: site, marker: siteMarker};
	}
	
	function _createSitePopup(site) {
		var siteInfoDOM = _d.div({ className : 'siteNameWrapper' },
			_d.p({ className : 'siteName' }, site.name )
		).get(0);
		return new mapboxgl.Popup().setDOMContent(siteInfoDOM);
	}

	function _drawHotelMarker(hotel) {
		var lnglat = new mapboxgl.LngLat(hotel.longitude, hotel.latitude);
		me.boundingBox.extend(lnglat);
		
		var hotelMarkerDOM = _d.i({ className : 'fa-solid fa-location-dot hotelMarker' }).get(0);
		
		var soldOut = !(hotel.avail.status === 'NORMAL' || hotel.avail.status === 'GDS');
		if(soldOut) {
			hotelMarkerDOM.className += ' filteredMarker';
		}
		
		var hotelMarker = new mapboxgl.Marker(hotelMarkerDOM, {offset: [0, -19]})
			.setLngLat(lnglat)
			.setPopup(_createHotelPopup(hotel))
			.addTo(me.map);
		return {hotel: hotel, marker: hotelMarker};
	}
	
	function _createHotelPopup(hotel) {
		if(_settings.popupUsesHotelCard) {
			var wrapper = _d.div();
			var hotelPopup;
			hotelPopup = new compass.hotel.HotelCardWidget(wrapper, {
				meetingInfo : _settings.meetingInfo,
				WUID : 'MapboxWidget_HotelCardWidget_' + _WUID,
				hotel : hotel,
				displayHotelStars: _settings.displayHotelStars,
				displayPriceSavings: _settings.displayPriceSavings,
				hideDistance: _settings.hideDistance,
	            hideNumberOfRoomsAvailable : _settings.hideNumberOfRoomsAvailable
			});
			return new mapboxgl.Popup().setDOMContent(wrapper.get(0));
			
		} else {
			var hotelPopupDOM = _d.div({ className : 'siteNameWrapper' },
				_d.p({ className : 'siteName' }, hotel.name )
			).get(0);
			return new mapboxgl.Popup().setDOMContent(hotelPopupDOM);
		}
	}
	
	function _drawMapControls() {
		var streetsStyleToggle = _d.span({className:'mapStyleToggle active', id:'streets'}, 'Streets')
			.click(handleMapStyleToggleClick);
		var satelliteStyleToggle = _d.span({className:'mapStyleToggle', id:'satellite'}, 'Satellite')
			.click(handleMapStyleToggleClick);
		
		$j('.MapboxWidget').append(
			_d.div({className: 'mapStyleToggleWrapper'}, 
				[
					streetsStyleToggle, 
					satelliteStyleToggle
				])
			);
		
		var zoomInButton = _d.div({className:'zoomButton', id:'zoomIn'}, '+')
			.click(function(e) {me.map.zoomIn()});
		var zoomOutButton = _d.div({className:'zoomButton', id:'zoomOut'}, '-')
			.click(function(e) {me.map.zoomOut()});
		
		$j('.MapboxWidget').append(
			_d.div({className: 'zoomButtonWrapper'},
				[
					zoomInButton,
					zoomOutButton
				])
		);
	}
	
	function handleMapStyleToggleClick(e) {
		var mapboxStyleToggle = $j(this);
		var mapboxStyleVarName = mapboxStyleToggle.attr('id') + 'StyleUrl';

		if(currentMapboxStyle !== styleUrls[mapboxStyleVarName]) {
			me.map.setStyle(styleUrls[mapboxStyleVarName]);
			$j('.mapStyleToggle.active').removeClass('active');
			mapboxStyleToggle.addClass('active');
			currentMapboxStyle = styleUrls[mapboxStyleVarName];
		}
	}
	
	function _setMarkerFiltered(hotelId) {
		var hotelMarkerPair = _.find(me.hotelMarkerPairs, function(hotelMarkerPair) {
			return hotelMarkerPair.hotel.hotelId === hotelId;
		});
		return function() {
			if(!me.getWidgetElem().is(':visible')) return;

			var markerEl = hotelMarkerPair.marker.getElement();
			$j(markerEl).addClass('filteredMarker');
			
			var popup = hotelMarkerPair.marker.getPopup();
			if (popup) popup.remove(); // remove from map instance
			hotelMarkerPair.marker.setPopup(null);
		};
	}
	
	function _setMarkerUnfiltered(hotelId) {
		var hotelMarkerPair = _.find(me.hotelMarkerPairs, function(hotelMarkerPair) {
			return hotelMarkerPair.hotel.hotelId === hotelId;
		});
		
		
		return function() {
			if ( hotelMarkerPair == null){ return; }
			
			if(!me.getWidgetElem().is(':visible')) return;
			
			hotelMarkerPair.marker.setPopup(_createHotelPopup(hotelMarkerPair.hotel));
			
			/* avail.status is set after checkin/checkout filter fetches avail data
				if hotel is soldout we shouldn't set unfiltered */
			var soldOut = !(hotelMarkerPair.hotel.avail.status === 'NORMAL' || hotelMarkerPair.hotel.avail.status === 'GDS');
			if(soldOut) return;
			
			var markerEl = hotelMarkerPair.marker.getElement();
			$j(markerEl).removeClass('filteredMarker');
		};
	}
	
	this.fetchMapbox = function() {
		var mapboxCSS = document.createElement('link');
		mapboxCSS.rel = 'stylesheet';
		mapboxCSS.type = 'text/css';
		mapboxCSS.href = 'https://api.tiles.mapbox.com/mapbox-gl-js/v3.2.0/mapbox-gl.css';
		document.getElementById('scriptTags').appendChild(mapboxCSS);
		
		var mapboxScript = document.createElement('script');
		mapboxScript.type = 'text/javascript';
		mapboxScript.src = 'https://api.tiles.mapbox.com/mapbox-gl-js/v3.2.0/mapbox-gl.js';
		// trigger draw on load of script, kind of like a callback for the mapbox fetch
		mapboxScript.onload = this.draw;

		document.getElementById('scriptTags').appendChild(mapboxScript);
	};
	
}, { // default settings
	'WUID' : 'crap',
	widgetName : 'MapboxWidget', 
	imgPath : 'resources/img',
	useSiteMarker : true,
	displayHotelStars : true,
	popupUsesHotelCard: true,
    hideNumberOfRoomsAvailable : false,
	hotels : [],
	mapbox : {
		streetsStyleUrl: 'mapbox://styles/onpeak/cja4c1bk32gzz2sp94fu4qkyx',
		satelliteStyleUrl: 'mapbox://styles/onpeak/cjalnf1rgcuh82roa8tohipk0',
		zoom: 14,
		padding: 50
	}
}
);